import React, { useCallback, useState } from 'react';
import { Grid, Typography, Box, Tabs, Tab } from '@mui/material';
import { withTransaction } from '@elastic/apm-rum-react';
import ProvidersList from './ProvidersList';
import MappersList from './MappersList';

/**
 * @component IDPSetting
 * @description IDPSetting - Renders a component for managing identity provider settings with tabs.
 * @returns {JSX.Element} IDPSetting component.
 */
const IDPSetting = () => {
  const [activeTab, setActiveTab] = useState(0);

  /**
   * @function handleTabChange
   * @description handleTabChange - Handles the tab change event.
   * @param {Event} event - The event object.
   * @param {number} newValue - The new tab value.
   */
  const handleTabChange = useCallback((event, newValue) => {
    setActiveTab(newValue);
  }, []);

  /**
   * @function TabPanel
   * @description TabPanel - Custom component to render tab content.
   * @param {Object} props - Component props.
   * @returns {JSX.Element} TabPanel component.
   */
  const TabPanel = ({ children, value, index }) => {
    return (
      <Box role="tabpanel" hidden={value !== index}>
        {value === index && children}
      </Box>
    );
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box
          display="flex"
          flexDirection="column"
          margin="20px"
          overflow="auto"
          mb={2}
        >
          <Box>
            <Typography variant="h3">Identity Provider</Typography>
          </Box>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{
              justifyContent: 'space-between',
              paddingLeft: '12px',
              flex: 1,
            }}
          >
            <Tab label="Providers" />
            <Tab label="Claim Mapping" />
          </Tabs>
        </Box>
        <Box p={2} display="flex" flexDirection="column" overflow="auto">
          <Box flexGrow={1} display="flex" flexDirection="column">
            <TabPanel value={activeTab} index={0}>
              <ProvidersList />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
              <MappersList />
            </TabPanel>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default withTransaction('IDPSetting', 'component')(IDPSetting);
